module.exports = __webpack_public_path__ + "images/application/email-674ab54c.svg";